import { useQuery } from '@tanstack/react-query';
import { searchService } from 'shared/src/api';
import { queryKey } from '../../../constants/queryKey';

export const useRelatedKeywords = (query: string, searchType: string) => {
  return useQuery({
    queryKey: queryKey.relatedKeywords(query, searchType),
    queryFn: () =>
      searchService.getRelatedKeywords({ query, search_type: searchType }),
    enabled: query.length > 0,
    staleTime: 1000 * 60 * 5, // 5분
  });
};